const clustering = require("density-clustering");

interface Geolocatable {
  latitude: number;
  longitude: number;
}

type Geolocation = { latitude: number; longitude: number };

type Meter = number;

// https://www.npmjs.com/package/haversine-distance
var atan2 = Math.atan2;
var cos = Math.cos;
var sin = Math.sin;
var sqrt = Math.sqrt;
var PI = Math.PI;

// (mean) radius of Earth (meters)
var R = 6378137;

function squared(x: number): number {
  return x * x;
}
function toRad(x: number): number {
  return (x * PI) / 180.0;
}

function haversineDistance(a: Geolocation, b: Geolocation): number {
  var aLat = a.latitude;
  var bLat = b.latitude;
  var aLng = a.longitude;
  var bLng = b.longitude;

  var dLat = toRad(bLat - aLat);
  var dLon = toRad(bLng - aLng);

  var f =
    squared(sin(dLat / 2.0)) +
    cos(toRad(aLat)) * cos(toRad(bLat)) * squared(sin(dLon / 2.0));
  var c = 2 * atan2(sqrt(f), sqrt(1 - f));

  return R * c;
}

function centroid(positions: Array<Geolocatable>) {
  const sumOfLatitudes = positions
    .map((position) => position.latitude)
    .reduce((a, b) => a + b);

  const sumOfLongitudes = positions
    .map((position) => position.longitude)
    .reduce((a, b) => a + b);

  return {
    latitude: sumOfLatitudes / positions.length,
    longitude: sumOfLongitudes / positions.length,
  };
}

const getCommonPosition = function (
  positions: Array<Geolocatable>,
  maxDistanceForCluster: Meter
): Geolocatable {
  if (positions.length === 1) {
    return positions[0];
  }

  let dbscan = new clustering.DBSCAN();
  const clusteredIndexes = dbscan.run(
    positions,
    maxDistanceForCluster,
    2,
    haversineDistance
  );

  if (clusteredIndexes.length === 0) {
    return null;
  }

  const biggestClusterIndexes = clusteredIndexes[0];
  const biggestClusterPositions = biggestClusterIndexes.map((index: number) => {
    return positions[index];
  });

  return centroid(biggestClusterPositions);
};

export {
  Geolocatable,
  Geolocation,
  getCommonPosition,
  haversineDistance,
  centroid,
};
